module.exports = class BreadCrumbModel
  constructor: ({@title, @friendlyName, @id, @href, @showSeparator, @showHref})->
    @showHref ?= true
    @showSeparator ?= true

  getTitle: ->
    @title ? @friendlyName
